import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface NotifyJobsDialogData {
  count: number;
  preference?: string;
  changing?: boolean;
}

@Component({
  selector: 'app-notify-jobs-dialog',
  template: `
    <h2 mat-dialog-title>ACTIVE JOBS</h2>
    <mat-dialog-content>
      <p>
        This patient now has {{ data.count }} active jobs. How should
        notifications be handled?
      </p>
      <p class="current" *ngIf="data.changing && data.preference">
        Current preference: {{ data.preference === 'WAIT_ALL' ? 'WAIT FOR ALL' : 'NOTIFY EACH' }}
      </p>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button type="button" (click)="dialogRef.close()">CANCEL</button>
      <button
        mat-stroked-button
        type="button"
        *ngIf="data.changing"
        (click)="dialogRef.close({ keep: true, preference: data.preference })"
      >
        KEEP PREFERENCE
      </button>
      <button mat-stroked-button type="button" (click)="dialogRef.close({ preference: 'EACH' })">
        NOTIFY FOR EACH JOB WHEN READY
      </button>
      <button mat-raised-button color="primary" type="button" (click)="dialogRef.close({ preference: 'WAIT_ALL' })">
        WAIT UNTIL ALL JOBS ARE READY
      </button>
    </mat-dialog-actions>
  `,
  styles: [
    `
          p {
            margin: 0 0 12px;
            line-height: 1.4;
          }
          .current {
            font-weight: 600;
          }
          /* TODO(mdc-migration): The following rule targets internal classes of dialog that may no longer apply for the MDC version. */
          mat-dialog-actions button {
            margin-left: 8px;
          }
        `,
  ],
})
export class NotifyJobsDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<NotifyJobsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: NotifyJobsDialogData
  ) {}
}
